import Paper from '@mui/material/Paper';
import { GridColDef, GridRowParams } from '@mui/x-data-grid';

import {
    DataGrid,
    DataGridCard,
    DataGridProps,
} from '@barboxx/admin-components';
import { BusinessSignup } from '@barboxx/models';
import { Address } from '@barboxx/types';

const columns: GridColDef[] = [
    { field: 'id', headerName: 'Id', width: 50, type: 'string' },
    { field: 'firstName', headerName: 'First Name', width: 150 },
    { field: 'lastName', headerName: 'Last Name', width: 150 },
    {
        field: 'email',
        headerName: 'Email',
        width: 200,
    },
    {
        field: 'businessName',
        headerName: 'Business Name',
        width: 150,
    },
    {
        field: 'phone',
        headerName: 'Phone',
        width: 130,
    },
    {
        field: 'status',
        headerName: 'Status',
        width: 100,
    },
    {
        field: 'address',
        headerName: 'Business City',
        align: 'right',
        flex: 1,
        valueFormatter: (value: Address) => {
            const { city, state, zip } = value;
            return `${city}, ${state}, ${zip}`;
        },
    },
];

interface RowItem extends BusinessSignup.WithNotesCount {
    actions?: undefined;
}

interface Props extends Omit<DataGridProps, 'onRowClick' | 'columns'> {
    data: RowItem[];
    onRowClick: (id: string) => void;
}

export default function SignupTable(props: Props) {
    const { data = [], onRowClick, ...rest } = props;

    const handleRowClick = (param: GridRowParams) => {
        onRowClick(param.id as string);
    };

    return (
        <Paper sx={{ width: '100%' }}>
            <DataGridCard>
                <DataGrid
                    columns={columns}
                    disableColumnMenu
                    disableRowSelectionOnClick
                    onRowClick={handleRowClick}
                    rows={data}
                    {...rest}
                />
            </DataGridCard>
        </Paper>
    );
}
